### 1. Klikamy "Tworzenie", a następnie wybieramy opcję "Projekt kwerendy".
![](https://i.imgur.com/NqBpuiM.png)

### 2. Wybieramy tabelę (lub kilka tabel), których potrzebujemy. Przeciągamy je, a następnie wybieramy potrzebne nam pola, aby dodać je do zapytania.
Łatwiej jest to zarówno wytłumaczyć, jak i zrozumieć na konkretnych danych. Weźmy więc pod lupę nasz **przykład**.

<img src={new URL('https://i.imgur.com/JMcc5YL.png', import.meta.url)} alt="xyz" className={'medium_img'} />

Będziemy potrzebować pola 'Pojemnosc_dysku', które znajduje się w tabeli 'Komputery'.
![](https://i.imgur.com/rZPiz77.png)
Zobaczmy, co zwróci powyższa kwerenda.

### 3. Jak uruchomić kwerendę?
Po prostu klikamy "Uruchom".
![](https://i.imgur.com/hVU6Q9P.png)
Widzimy, że nie jest to odpowiedź, jakiej oczekujemy, mamy bowiem po prostu spis pojemności dysków wszystkich komputerów.

### 4. Jak edytować uruchomioną kwerendę?
Możemy kliknąć opcję "Widok", a następnie wybrać "Widok projektu" (1.) lub przełączyć widok za pomocą skrótu (2.)
![](https://i.imgur.com/9McFZlf.png)

### 5. Funkcja "Sumy".
Czego zatem jeszcze potrzebujemy?
Po pierwsze, chcemy wiedzieć, jakie jest 10 najczęściej występujących rodzajów (pojemności) dysków.
Musimy zatem pogrupować dyski względem wielkości oraz policzyć, ile dysków danej pojemności występuje w naszej bazie danych.
Przydatna do tego celu będzie funkcja "Sumy".
![](https://i.imgur.com/c0RiMjv.png)
Widzimy, że pojawiło się nowe pole, którego domyślna wartość to "Grupuj według". Mamy dostępne również inne opcje.
![](https://i.imgur.com/nm6QFxh.png)

### 6. Opcje "Sumy".
<img src={new URL('https://i.imgur.com/DeehW9R.png', import.meta.url)} alt="xyz" className={'super_small_img'} />
Większość opcji jest na tyle prostych, że tłumaczy się poprzez nazwę, na przykład "Suma" sumuje wartości z danej kolumny dla wszystkich rekordów będących w danej grupie.
Ważne, a być może nie tak intuicyjne są następujące opcje:

* Wyrażenie — wybieramy je, gdy w wierszu "Pole" zamiast standardowej nazwy jednej kolumny używamy całego wyrażenia. Co to dokładnie oznacza, opiszę w dziale "3.3. Konstruowanie wyrażeń".

* Gdzie — działa podobnie do "Grupuj według", jednak nie wyświetla danej kolumny w wyniku działania kwerendy. Zazwyczaj używamy go, gdy chcemy dodać jakiś warunek do wiersza "Kryteria".

Jeśli użycie powyższych opcji wciąż nie jest jasne, nie martw się. Najlepiej i najłatwiej jest zrozumieć je na konkretnych zadaniach.

**W naszym przykładzie**, tak jak już powiedzieliśmy, potrzebujemy informacji o 10 najczęściej występujących pojemnościach dysku.
Chcemy zatem pogrupować komputery według kolumny 'Pojemność_dysku', a następnie policzyć ile komputerów mamy w każdej z tych grup. Jednak w jaki sposób mamy to zrobić? Przydatne okaże się pole 'Numer_komputera'. Wiemy, że jest to klucz główny w tabeli 'Komputery', a więc każdy z numerów będzie występował w niej co najwyżej jeden raz.
Podsumowując, chcemy pogrupować komputery według kolumny 'Pojemność_dysku', a następnie policzyć 'Numer_komputera'.
<img src={new URL('https://i.imgur.com/yLI2O7M.png', import.meta.url)} alt="xyz" className={'small_img'} />
Teraz mamy już informację o liczbie komputerów z daną pojemnością dysku.

![](https://i.imgur.com/Lg73rRv.png)
Nas interesuje jednak 10 najczęściej występujących pojemności. Możemy wyszukać je ręcznie,
ale oczywiście nie jest to dobre rozwiązanie, szczególnie przy dużej ilości danych.
Co zatem zrobimy? Wystarczy posortować wyniki malejąco.

### 7. Sortowanie.
![](https://i.imgur.com/YhyoW73.png)
Na tym moglibyśmy poprzestać i skopiować do pliku z odpowiedziami pierwsze 10 rekordów.
Jest jednak lepsze rozwiązanie. Możemy ograniczyć liczbę rekordów w wyniku jeszcze na poziomie kwerendy.

### 8. Limit.
![](https://i.imgur.com/RNg8Nts.png)
Wystarczy, że wybierzemy, żeby nasza kwerenda zwracała 10 rekordów zamiast wszystkie.
![](https://i.imgur.com/4nUe2DX.png)
Nasza kwerenda zwraca wynik zgody z naszymi oczekiwaniami, możemy więc już zapisać jej wynik.

### 9. Zapisujemy kwerendę.
Możemy to zrobić za pomocą skrótu klawiszowego "Ctrl+S". Warto pamiętać o dobrym nazewnictwie kwerend.
Teoretycznie nie jest to wymóg formalny, ale nie chcemy przecież denerwować egzaminatora sprawdzającego naszą pracę.

### 10. Zapisz odpowiedź w pliku tekstowym!!!
<img src={new URL('https://i.imgur.com/vbmsmge.png', import.meta.url)} alt="xyz" className={'medium_img'} />

Jeśli rozwiązanie będzie w pełni poprawne, ale nie zapiszesz odpowiedzi w pliku (w naszym przykładzie "wyniki6.txt") to nie dostaniesz za nie punktów.
<img src={new URL('https://i.imgur.com/rlR2EcS.png', import.meta.url)} alt="xyz" className={'small_img'} />

**Cała instrukcja jest bardzo ważna**, ale w tym miejscu zwróćmy szczególną uwagę na zaznaczony fragment.
